module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.address_id),
      expression: "address_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.address_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("[Keine Hauptadresse]")]), _vm._v(" "), _vm._l((_vm.content), function(entry) {
    return _c('option', {
      domProps: {
        "value": entry.id
      }
    }, [_vm._v(_vm._s(entry.text))])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a2da466!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/custom-select.vue
// module id = 425
// module chunks = 0